/**
 * Shared quota error codes emitted by the API server and consumed by the
 * client-side quota-banner helpers.  Both sides must reference this file so
 * that a rename on either end produces an immediate TypeScript compile error
 * rather than a silent banner disappearance.
 *
 * This file intentionally has zero imports — it is safe to load in both a
 * Node.js/Express context and a Vite/browser context.
 */

export const QUOTA_CODES = {
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED",
  TRIAL_QUOTA_EXCEEDED: "TRIAL_QUOTA_EXCEEDED",
  TRIAL_QUOTA_ENFORCED: "TRIAL_QUOTA_ENFORCED",
} as const;

/** Total quote creations allowed across an account's free trial, irrespective of its duration. */
export const TRIAL_QUOTA_TOTAL = 5;

export type QuotaErrorCode = (typeof QUOTA_CODES)[keyof typeof QUOTA_CODES];

/**
 * Ordered tuple of all quota error codes — used by `isQuotaErrorCode` on the
 * client to identify 429 responses that should trigger the quota banner.
 */
export const QUOTA_ERROR_CODES = [
  QUOTA_CODES.QUOTA_EXCEEDED,
  QUOTA_CODES.TRIAL_QUOTA_EXCEEDED,
  QUOTA_CODES.TRIAL_QUOTA_ENFORCED,
] as const satisfies readonly QuotaErrorCode[];
